<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-4">
        {{ $t('messages.change_email_modal.title') }}
      </h3>
      <p class="ml-6 mr-6 mb-10 text-zyxel-gray-800">
        {{ $t('messages.change_email_modal.description') }}
      </p>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="mb-4 button-cancel min-w-[120px]"
          @click="cancel"
        >
          {{ $t("messages.button.cancel") }}
        </button>
        <button
          class="ml-3 mb-4 mr-4 button-primary min-w-[120px]"
          @click="change"
        >
          {{ $t('messages.button.change') }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-primary w-full mb-4"
          @click="change"
        >
          {{ $t('messages.button.change') }}
        </button>
        <button
          class="button-cancel w-full mb-6"
          @click="cancel"
        >
          {{ $t("messages.button.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailChangeDialog",
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    change() {
      this.$emit('change');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
}
</script>